import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntTextExpanderComponent} from "./int-text-expander.component";
import {IntTextClampModule} from "../../../pipes";
import {IntBorderedButtonModule} from "../../buttons";
import {IntIconModule} from "../../int-icon";
import {IntEmptyDividerModule} from "../../dividers";

@NgModule({
  imports: [
    CommonModule,
    IntTextClampModule,
    IntBorderedButtonModule,
    IntIconModule,
    IntEmptyDividerModule
  ],
  declarations: [
    IntTextExpanderComponent
  ],
  exports: [
    IntTextExpanderComponent
  ]
})
export class IntTextExpanderModule {}
